import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {PaisesComponent} from '../paises.component'
//Services
import {CountryService} from 'src/app/core/services/parameters/country.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearPaisModal implements OnInit {

  newCountryForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<PaisesComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private countryService: CountryService
  ) {
  }

  ngOnInit(): void {
    this.newCountryForm = this.fb.group({
      country: [, Validators.required],
      codeCounty: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newCountryForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newCountryForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.country,
        code: form.value.codeCounty
      }
      this.countryService.createCountry(data).subscribe(_res => {
        this.alert.setNotice('Pais creada correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el pais', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
